// extracted by mini-css-extract-plugin
export default {"block":"skeleton_block__e8nGX","skeleton-animation":"skeleton_skeleton-animation__tkE1X","text":"skeleton_text__YhJ8Y","textInner":"skeleton_textInner__8YpQG"};